const useCdnUrl = (value: string | null | undefined): string | null => {
  if (value && typeof value === 'string') {
    return value;
  }
  return null;
};

export { useCdnUrl };
